import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { PerformanceRecord } from '@/types/performanceRecord';

export const getPerformanceRecordsByChildIDForLine = async (
  childID: number,
  lineAccessToken: string
): Promise<ApiResult<PerformanceRecord[]>> => {
  const { status, result } = await callApiWithoutToken<PerformanceRecord[]>(
    `line/children/${childID}/performance-records`,
    'GET',
    lineAccessToken
  );
  return { status, result };
};
